import React from "react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BaseUrl } from "../../../helper/BaseUrl";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import ContactForm from "../../contactUs/ContactForm";

const countries = [
  {
    image: "/assets/images/country-monuments1.webp",
    name: "INDIA",
    flag: "/assets/images/countery-flag-2.webp",
    address: "DLF Phase 2, Sector 25, Gurugram, Haryana, India 122022.",
    phone: "+1 (518) 719-2882",
  },
  {
    image: "/assets/images/country-monuments2.webp",
    name: "TAIWAN",
    flag: "/assets/images/countery-flag-1.webp",
    address:
      "16F,No. 19, Alley 31, Lane 743, Section 5, Zhongxiao East Road, Neighborhood 6, Yongchun Village, Xinyi District, Taipei City, Taiwan 0066854616.",
    phone: "+1 (518) 719-2882",
  },

  {
    image: "/assets/images/country-monuments3.webp",
    name: "USA",
    flag: "/assets/images/countery-flag-3.webp",
    address: "16192 Coastal Highway, Lewes, Delaware 19958, County of Sussex.",
    phone: "+1 (518) 719-2882",
  },
  {
    image: "/assets/images/country-monuments4.webp",
    name: "ITALY",
    flag: "/assets/images/countery-flag-4.webp",
    address: "Viale D’Agostino 51, Imola (BO) 40026.",
    phone: "+1 (518) 719-2882",
  },
];

export default function GroceriesContact() {
  const [activeIndex, setActiveIndex] = useState(0);
  const total = countries.length;

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % total);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + total) % total);
  };

  return (
    <>
      <section className="groceries-contact-section contact-form">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-6">
              <div className="groceries-map-box">
                <div className="contact-text">
                  <p className="contact-title">    Partner with tech catalysts who transform ideas into impact.   </p>
                  <p className="contact-desc">  Book your free consultation with us. </p>
                  <p className="contact-subtitle">Let's talk</p>
                </div>

                <div className="country-slider fade-slider">
                  {/* Arrows */}
                  <div className="slider-arrows">
                    <button onClick={handlePrev}>   <i className="fa-solid fa-arrow-left"></i> </button>
                    <button onClick={handleNext}>  <i className="fa-solid fa-arrow-right"></i>  </button>
                  </div>

                  {/* Slider */}
                  <div className="slider-window">
                    {countries.map((item, index) => (
                      <div key={index} className={`fade-slide ${activeIndex === index ? "active" : ""}`} >
                        <div className="monumentimg-box">
                          <img src={item.image} alt={item.name} />
                        </div>
                        <div className="monument-text">
                          <p className="country-title">{item.name}</p>
                          <p>{item.address}</p>
                          <a href={`tel:${item.phone}`}>{item.phone}</a>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Tabs */}
                  <div className="country-tabs">
                    {countries.map((item, index) => (
                      <button key={index} className={activeIndex === index ? "active" : ""} onClick={() => setActiveIndex(index)}  >
                        <span> <img src={item.flag} alt={item.name} />  </span>  {item.name}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-12 col-lg-6">
              <div className="form-box form-wrapper">
                <div className="form-title heading">   Speak to an Expert Today!  </div>
                <p>
                  Get in touch with our battle-tested sustainability,
                  technology, and TMS specialists to explore tailored green
                  logistics solutions.
                </p>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
        <img className="bigmap-img" src="/assets/images/big-map.webp" alt="Tailored" />
      </section>
    </>
  );
}
